import { showToast } from "./showToast";
import { ASSET_MAX_FILE_UPLOAD_SIZE } from "./constants";

const mimeTypes = {
  "image/gif": ["gif"],
  "image/png": ["png"],
  "image/jpeg": ["jpeg", "jpg", "jpe"],
  "video/mp4": ["mp4"],
  "video/quicktime": ["mov", "qt"],
  // add more if you need - https://github.com/jshttp/mime-db/blob/master/db.json
};

export const getExtension = (mimeType) => mimeTypes[mimeType]?.[0];

export const getMimeType = (extension) =>
  Object.keys(mimeTypes).find((mimeType) =>
    mimeTypes[mimeType]?.includes(extension)
  );

export const onRejectFileDropzone = (rejectedFiles, t, fontOnly = false) => {
  if (rejectedFiles.length) {
    rejectedFiles.forEach((rejectedFile) => {
      if (!rejectedFile.errors) return;
      rejectedFile.errors.forEach((err) => {
        if (err.code === "file-too-large") {
          showToast({
            title: t("upload_size_error", {
              size: ASSET_MAX_FILE_UPLOAD_SIZE / (1024 * 1024), // convert to MB
            }),
            description: rejectedFile.file.path,
            status: "error",
          });
        } else if (err.code === "file-invalid-type") {
          if (fontOnly) {
            showToast({
              title: t("asset_invalid_file_error_title", {
                ns: "common",
                path: rejectedFile.file.path,
              }),
              description: t("asset_only_accept_font_file_error_descriptions", { ns: "common" }),
              status: "error",
            });
          } else {
            showToast({
              title: t("asset_invalid_file_error_title", {
                ns: "common",
                path: rejectedFile.file.path,
              }),
              description: t("asset_invalid_file_error_description", { ns: "common" }),
              status: "error",
            });
          }
        } else {
          showToast({
            title: err.message,
            description: rejectedFile.file.path,
            status: "error",
          });
        }
      });
    });
  }
};
